import React from 'react';

interface EditAdditionalInfoProps {
  form: any;
  onChange: (field: string, value: any) => void;
}

export function EditAdditionalInfo({ form, onChange }: EditAdditionalInfoProps) {
  return (
    <div className="bg-white p-3 rounded-md border border-slate-100 space-y-4">
      <div className="flex items-center gap-2 border-b border-slate-50 pb-2">
        <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs">3</div>
        <h2 className="sm:text-sm text-xs text-slate-800">Chi tiết bổ sung</h2>
      </div>

      {form.work_type === 'maintenance' && (
        <div className="pt-4 border-t border-slate-50">
          <div className="flex items-center gap-2 mb-3">
            <i className="ri-list-settings-line text-emerald-600" />
            <h3 className="sm:text-sm text-xs text-slate-700">Thông số bảo dưỡng</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <MaintenanceField label="Diện tích tổng (m²)" value={form.area_m2} onChange={(val) => onChange('area_m2', val)} />
            <MaintenanceField label="Số lượng cây (gốc)" value={form.tree_count} onChange={(val) => onChange('tree_count', val)} />
            <MaintenanceField label="Diện tích cỏ (m²)" value={form.lawn_area_m2} onChange={(val) => onChange('lawn_area_m2', val)} />
            <MaintenanceField label="Diện tích bụi (m²)" value={form.shrub_area_m2} onChange={(val) => onChange('shrub_area_m2', val)} />
            <MaintenanceField label="Dài hàng rào (m)" value={form.hedge_length_m} onChange={(val) => onChange('hedge_length_m', val)} />
            <MaintenanceField label="Lượng vật tư" value={form.material_quantity} onChange={(val) => onChange('material_quantity', val)} />
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Tài liệu đính kèm</label>
          <div className="border-2 border-dashed border-slate-100 rounded-md p-6 flex flex-col items-center justify-center gap-2 bg-slate-50/30 hover:bg-slate-50 transition-colors cursor-pointer">
            <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
              <i className="ri-upload-cloud-2-line text-xl" />
            </div>
            <div className="text-center">
              <p className="sm:text-sm text-xs text-slate-600">Kéo thả file vào đây hoặc <span className="text-emerald-600">Chọn file</span></p>
              <p className="sm:text-sm text-xs text-slate-400 mt-1">Hỗ trợ: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG (Tối đa 20MB)</p>
            </div>
          </div>
        </div>

        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Ghi chú</label>
          <div className="relative h-full">
            <textarea
              placeholder="Nhập ghi chú (nếu có)"
              className="w-full h-[110px] p-3 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50 resize-none"
              value={form.notes}
              onChange={(e) => onChange('notes', e.target.value)}
              maxLength={500}
            />
            <span className="absolute right-2 bottom-2 sm:text-sm text-xs text-slate-400">{form.notes?.length || 0}/500</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function MaintenanceField({ label, value, onChange }: { label: string; value: any; onChange: (val: string) => void }) {
  return (
    <div className="space-y-1">
      <label className="sm:text-sm text-xs text-slate-400">{label}</label>
      <input
        type="text"
        className="w-full h-9 px-3 rounded-md border border-slate-100 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/30"
        placeholder="0"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
